module.exports = __webpack_public_path__ + "static/media/3dots.556f3a3a.svg";